<div NgxLoadingXBlur class="h-100">
  <div class="contain">
    <img class="image" src="/assets/images/LOGO-55.png">
    <div class="text-container">
      <h1 class="text-center title">Administración</h1>
      <h1 class="text-center text">Cambiar Contraseña</h1>
    </div>

    <mat-card>
      <mat-card-content>
        <form novalidate [formGroup]="loginForm" #lform="ngForm" (ngSubmit)="changePassword()">
          <mat-form-field class="full-width-input">
            <mat-label class="text-field">Contraseña Nueva</mat-label>
            <input matInput formControlName="newPassword" required [type]="!passwordIsActive ? 'password': 'text'"
            name="newPassword" autocomplete="off">
            <mat-icon class="icon-cursor" matSuffix (click)="passwordIsActive = !passwordIsActive"
              matTooltip="{{ !passwordIsActive ? 'Mostrar contraseña' : 'Ocultar contraseña'}}">
              {{ !passwordIsActive ? 'visibility': 'visibility_off' }}
            </mat-icon>
            <mat-error *ngIf="formErrors.newPassword">{{formErrors.newPassword}}</mat-error>
          </mat-form-field>
          <mat-form-field class="full-width-input mt-2">
            <mat-label class="text-field">Confirmar Contraseña</mat-label>
            <input matInput [type]="!passwordIsActive2 ? 'password': 'text'"
              name="confirmPassword" autocomplete="off"
              #Input (keyup)="verifyPassword(Input.value)">
            <mat-icon class="icon-cursor" matSuffix (click)="passwordIsActive2 = !passwordIsActive2"
              matTooltip="{{ !passwordIsActive2 ? 'Mostrar contraseña' : 'Ocultar contraseña'}}">
              {{ !passwordIsActive2 ? 'visibility': 'visibility_off' }}
            </mat-icon>
          </mat-form-field>
          <mat-error class="confirm-pass-error" *ngIf="confirmPassMsg !== ''">
            {{confirmPassMsg}}
          </mat-error>
          <div class="mt-3">
            <button mat-raised-button
                    class="btn-login" type="submit"
                    [disabled]="(confirmPassMsg !== '') || loginForm.invalid">Cambiar</button>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>
<ngx-loading-x [show]="isLoading"></ngx-loading-x>